import { Component, Input, SimpleChanges } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { BehaviorSubject, combineLatest, map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { ProductService } from 'src/app/services/product.service';
import { Units } from 'src/interfaces/enums.model';
import { Food, FoodOrder } from 'src/interfaces/food.model';
import { Locale } from 'src/interfaces/locale.model';
import { Modificators } from 'src/interfaces/modificators.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-order-food-card',
    templateUrl: './menu-order-food-card.component.html',
    styleUrls: ['./menu-order-food-card.component.css'],
    standalone: false
})
export class MenuOrderFoodCardComponent {
  constructor(
    private dataService: DataService,
    private imageCache: ImageCacheService,
    private productService: ProductService
  ) {
    this.locale = this.dataService.locale;
    this.guestId = this.dataService.guestId;
  }

  food: Food | null = null;
  modificators: Modificators | null = null;
  locale: Locale | null = null;
  guestId: string;
  unit: Units = Units.unit;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.food;

  @Input() foodOrder: FoodOrder | null = null;
  @Input() isLast: boolean = false;

  private destroy$ = new Subject<void>();
  private foodSubject = new BehaviorSubject<FoodOrder | undefined>(undefined);

  ngOnInit(): void {
    console.log('OrderFoodCard | ngOnInit() | foodOrder: ', this.foodOrder?.title, 'status', this.foodOrder?.status);
    if (this.foodOrder) {
      this.foodSubject.next(this.foodOrder);
    }
    combineLatest([this.foodSubject, this.productService.foods$]).pipe(
      takeUntil(this.destroy$),
      map(([food, foods]) => food ? foods.filter(f => f.id === food.id) : []),
    ).subscribe(filtered => {
      if (filtered.length && this.foodOrder) {
        this.food = cloneDeep(filtered[0]);
        console.log('OrderFoodCard | subscribe() | food: ', this.food.title);
        // Image
        if (this.food.image?.trim()) {
          this.imageCache.getImage(this.food.image, NO_PHOTO.food).then(src => {
            this.imageSrc = src;
          });
        }

        // Count
        if (this.foodOrder.count) {
          this.food.count = this.foodOrder.count;
        }

        // Price
        if (this.foodOrder.price) {
          this.food.price = this.foodOrder.price;
        }

        // Choise
        if (this.foodOrder.choise) {
          this.food.choise = this.foodOrder.choise;
        }

        // Восстановление модификаторов
        if (this.foodOrder?.modificators && typeof this.foodOrder.modificators === 'object') {
          const orderModificators = this.foodOrder.modificators || [];

          // Восстанавливаем модификаторы
          const modificators = typeof this.food.modificators === 'object' ? this.food.modificators : undefined;
          if (modificators) {
            this.modificators = cloneDeep(this.food.modificators) as Modificators;
            this.modificators.items.forEach((modificator: any) => {
              const orderModificator = orderModificators.find((item: any) => item.id === modificator.id);
              if (orderModificator) {
                modificator.count = orderModificator.count;
              }
            });
            this.modificators.items = this.modificators.items.filter((modificator: any) => modificator.count > 0);
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['foodOrder'] && changes['foodOrder'].currentValue !== changes['foodOrder'].previousValue) {
      this.foodSubject.next(changes['foodOrder'].currentValue);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get localSize(): string {
    return this.food?.size ? this.food?.size.toLocaleString('ru-RU', { useGrouping: true }) : '';
  }
}
